import { FieldPath } from '@angular/fire/firestore';

export class SearchQueryModel {
    field: string | FieldPath;
    compareValue: any;
}

export type SearchQuery = SearchQueryModel | undefined;
